import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  baseHomeController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'authService',
    '$location',
    '$filter',
    'PermPermissionStore',
    '$state',
    '$timeout',
    '$window',
    'searchService',
    '$uibModal',
    'fileUploadService',
    'linkFilesService',
    'EAdminFeatures',
    'webApiSettings',
    'notificationService',
    'systemConfigService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      authService,
      $location,
      $filter,
      PermPermissionStore,
      $state,
      $timeout,
      $window,
      searchService,
      uibModal,
      fileUploadService,
      linkFilesService,
      EAdminFeatures,
      webApiSettings,
      notificationService,
      systemConfigService
    ) {
      'use strict';

      function onbeforeunload(e) {
        var isSendingFiles = $scope.verifySendFilesRunCallback();
        if (isSendingFiles) {
          e.returnValue = $filter('translate')('ONBEFOREUNLOAD MESSAGE');
          return $filter('translate')('ONBEFOREUNLOAD MESSAGE');
        } else {
          return undefined;
        }
      }

      function onCloseSearch() {
        $scope.showSearch = false;
      }

      function onTreeItemSelected() {
        $rootScope.showSidebar = false;
      }

      function showModules() {
        if (authService.user.email !== '') {
          if (authService.authentication.email === 'autologin') return false;
          if (authService.isAdmin()) return true;

          var anyAdminFeature =
            authService.user.adminFeatures &&
            authService.user.adminFeatures.some(
              (af) => af.IdAdminFeature !== EAdminFeatures.ManageFolders
            );
          return (
            anyAdminFeature ||
            PermPermissionStore.hasPermissionDefinition('WORKFLOW')
          );
        }
        return false;
      }

      function showSecurityModule() {
        var lstFeatures = [
          EAdminFeatures.ManageRoles,
          EAdminFeatures.ManageGroups,
          EAdminFeatures.ManageUsers,
        ];
        var canShow = authService.verifyHasAdminFeature(lstFeatures);
        return canShow;
      }

      function showCrudModule() {
        var lstFeatures = [
          EAdminFeatures.ManageRepositories,
          EAdminFeatures.ManageDocumentTypes,
          EAdminFeatures.ManageAdditionalFields,
          EAdminFeatures.ManageDataLists,
          EAdminFeatures.ConfigureSystemOptions,
        ];
        var canShow = authService.verifyHasAdminFeature(lstFeatures);
        return canShow;
      }

      function showReportModule() {
        var lstFeatures = [EAdminFeatures.ViewReports];
        var hasAdminFeature = authService.verifyHasAdminFeature(lstFeatures);
        var isAdmin = authService.isAdmin();
        var isSysAdmin = authService.isSysAdmin();

        return hasAdminFeature || isAdmin || isSysAdmin;
      }

      function showWorkflowModule() {
        return PermPermissionStore.hasPermissionDefinition('WORKFLOW');
      }

      function showMediaModule() {
        var lstFeatures = [EAdminFeatures.ExportMedia];
        var isAdmin = authService.isAdmin();
        var hasAdminFeature = authService.verifyHasAdminFeature(lstFeatures);
        var hasFeature =
          PermPermissionStore.hasPermissionDefinition('EXPORT_MEDIA');
        var isSysAdmin = authService.isSysAdmin();

        return hasFeature && (hasAdminFeature || isAdmin || isSysAdmin);
      }

      function showNfeModule() {
        var lstFeatures = [EAdminFeatures.ManageNFes];
        var hasAdminFeature = authService.verifyHasAdminFeature(lstFeatures);
        var hasFeature = false;
        var isAdmin = authService.isAdmin();
        var isSysAdmin = authService.isSysAdmin();

        return hasFeature && (hasAdminFeature || isAdmin || isSysAdmin);
      }

      function getLogoImg() {
        if (!webApiSettings.showCompaniesLogo)
          return '/assets/images/logo/logo_branca.png';
        if ($scope.company && $scope.company.Logo)
          return `${webApiSettings.apiServiceBaseUri}companies/${$scope.company.Id}/logo`;
        if (webApiSettings.detailsCompany === 'hdoc')
          return '/assets/images/logo/logo_branca_HDOC.png';
        if (webApiSettings.detailsCompany === 'abase')
          return '../../assets/images/logo/abase.png';
        if (webApiSettings.detailsCompany === 'rb')
          return '../../assets/images/logo/rb.png';
        return '/assets/images/logo/logo_branca.png';
      }

      function filterModules(module) {
        return module && module.canShow();
      }

      function currentModule() {
        var module = $scope.modules.filter(
          (m) => $state.current.name.indexOf(m.baseRef) > -1
        )[0];

        return module;
      }

      function updateShowBar() {
        $rootScope.showSidebar = !$rootScope.showSidebar;
      }

      function updateShowSearch() {
        $scope.showSearch = !$rootScope.showSidebar;
      }

      function validateCompany() {
        $state.current.abase = false;
        $state.current.hdoc = false;
        $state.current.digitaldoc = false;
        $state.current.rb = false;

        switch (webApiSettings.detailsCompany) {
          case 'abase':
            $state.current.abase = true;
            break;
          case 'hdoc':
            $state.current.hdoc = true;
            break;
          case 'digitaldoc':
            $state.current.digitaldoc = true;
            break;
          case 'rb':
            $state.current.rb = true;
            break;
        }
      }

      function showChangePass() {
        $rootScope.showChangePassModal = uibModal.open({
          animationEnabled: true,
          templateUrl: '/views/partials/changePass.html',
          controller: 'userController',
          windowClass: 'modalChangePass',
          backdrop: 'static',
          keyboard: false,
          size: 'large',
          resolve: {
            isChangeOnLogin: () => false,
            currentPass: () => '',
          },
        });
      }

      function showWiki() {
        authService.userLogs();
      }

      function showSupportModal() {
        uibModal.open({
          animationEnabled: true,
          controller: 'supportController',
          windowClass: 'modalSupport',
          templateUrl: '/views/partials/newSupportTicket.html',
          backdrop: 'static',
          keyboard: false,
        });
      }

      function showSupportWhatsapp() {
        let config = systemConfigService.getConfig();
        const defaultNumber = '+5545999470298';
        let phone = config?.phoneForSupport;

        if (phone) {
          phone = phone.replace(/\D/g, '');

          if (!phone.startsWith('55')) {
            phone = '55' + phone;
          }

          phone = '+' + phone;
        } else {
          phone = defaultNumber;
        }

        const url = `https://wa.me/${phone}`;

        window.open(url, '_blank', 'noopener,noreferrer');
      }

      function goToMyDocuments() {
        var lstStatesNotChange = ['home.list', 'home.folder'];
        if (lstStatesNotChange.indexOf($state.current.name) < 0)
          $state.go('home.list');
      }

      function verifySendFilesRunCallback() {
        var items = $scope.uploader.queue.filter((item) => item.isUploading);
        return items.length > 0;
      }

      function cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function questionModal() {
        notificationService.closeNotification();

        return new Promise((resolve) => {
          $scope.uploader.cancelAll();
          $scope.uploader.clearQueue();
          var isAutologin = authService.authentication.email === 'autologin';
          var isExternalLogin = authService.authentication.isExternalLogin;
          authService.logOut();

          linkFilesService.reset();

          window.location.reload();
          $timeout(() => {
            $state.params = [];
            $state.go('login');
          }, 0);
          if (isExternalLogin || isAutologin) window.close();
          resolve();
        });
      }

      function logOut() {
        var isSendingFiles = $scope.verifySendFilesRunCallback();
        var linkingTitle = linkFilesService.isLinkingFiles
          ? $filter('translate')('LINKING FILES')
          : $filter('translate')('CONFIRM LOGOFF');
        var confirmText = linkFilesService.isLinkingFiles
          ? $filter('translate')('CONFIRM LOGOFF LINKING FILES')
          : $filter('translate')('CONFIRM LOGOFF MSG');

        $scope.messageTitle = isSendingFiles
          ? $filter('translate')('SENDING FILES')
          : linkingTitle;
        $scope.messageDescription = isSendingFiles
          ? $filter('translate')('CONFIRM LOGOFF ANYWAY')
          : confirmText;
        $scope.messageForward = $filter('translate')('LOGOFF');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'baseHomeController',
          size: 'small',
          windowClass: 'modal-remove',
        });
      }

      function switchCompany(company) {
        if (company.Id === $scope.company.Id) return;

        if (company.Contract.IdContractStatus !== 1) {
          swal.fire({
            title: $filter('translate')('WARNING'),
            text: $filter('translate')('BLOQUED CONTRACT'),
            allowOutsideClick: false,
            showConfirmButton: true,
            allowEscapeKey: false,
            icon: 'info',
          });
          return;
        }

        var isSendingFiles = $scope.verifySendFilesRunCallback();

        var linkingTitle = linkFilesService.isLinkingFiles
          ? $filter('translate')('LINKING FILES')
          : $filter('translate')('CONFIRM LOGOFF');
        var confirmText = linkFilesService.isLinkingFiles
          ? $filter('translate')('CONFIRM CHANGE COMPANY LINKING FILES')
          : $filter('translate')('CONFIRM LOGOFF MSG');

        if (isSendingFiles || linkFilesService.isLinkingFiles) {
          swal.fire({
            title: isSendingFiles
              ? $filter('translate')('SENDING FILES')
              : linkingTitle,
            text: isSendingFiles
              ? $filter('translate')('CONFIRM CHANGE COMPANY ANYWAY')
              : confirmText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return new Promise((resolve) => {
                $scope.uploader.cancelAll();
                $scope.uploader.clearQueue();
                $scope.doSwitchCompany(company.Id);
                resolve();
              });
            },
          });
        } else {
          $scope.doSwitchCompany(company.Id);
        }
      }

      function doSwitchCompany(idCompany) {
        swal.fire({
          title: $filter('translate')('SWITCHING COMPANY'),
          text: $filter('translate')('SWITCHING COMPANY MSG'),
          allowOutsideClick: false,
          showConfirmButton: false,
          allowEscapeKey: false,
          icon: 'info',
        });

        authService
          .switchCompany(idCompany)
          .then(() => {
            $scope.loadCompanyImage(idCompany);

            searchService.setSearchConfigs();
            swal.close();
            top.location.reload();
          })
          .catch((data) => {
            swal.fire({
              title: data.error,
              text: data.error_description,
              icon: 'error',
            });
          });
      }

      function loadCompanyImage(id) {
        if (runtimeConstant.shouldLoadCompanyImage === false) {
          $scope.companyLogo = null;
          $scope.hasntCompanyImage = true;
          return;
        }

        authService
          .getCompanyLogo(id)
          .then((logo) => {
            $scope.companyLogo = logo;
            $scope.hasntCompanyImage = false;
          })
          .catch(() => {
            $scope.companyLogo = null;
            $scope.hasntCompanyImage = true;
          });
      }

      function initialize() {
        $scope.user = $rootScope.user;
        $scope.validateCompany;
        if ($scope.user === undefined) {
          authService.loadUser().then((user) => {
            $rootScope.user = user;
            $scope.user = user;
            if (user.changePass) {
              $timeout(() => {
                var modal = uibModal.open({
                  animationEnabled: true,
                  templateUrl: '/views/partials/changePass.html',
                  controller: 'userController',
                  windowClass: 'modalChangePass',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    isChangeOnLogin: () => true,
                    currentPass: () => user.pass,
                  },
                });

                modal.result
                  .then(() => {
                    $scope.loadData();
                  })
                  .catch(() => {
                    authService.logOut();
                    $location.path('/login');
                  });
              });
            } else {
              $scope.loadData();
            }
          });
        } else {
          $scope.loadData();
        }
      }

      function loadData() {
        $scope.isAutologin = authService.authentication.email === 'autologin';
        $scope.loggedUser = $scope.isAutologin
          ? $scope.user.name
          : $scope.user.email;
        var lastCompany =
          $scope.user.userPreferences.IdLastCompany !== undefined
            ? $scope.user.userPreferences.IdLastCompany
            : 0;
        searchService.setSearchConfigs();
        $scope.loadCompanyImage(lastCompany);

        $scope.company = $scope.isAutologin
          ? $scope.user.companies[0].Company
          : $scope.user.companies.filter((c) => c.IdCompany === lastCompany)[0]
              .Company;

        if (!$scope.loggedUser) {
          var head = document.getElementsByTagName('head').item(0);
          var script = document.createElement('script');
          script.setAttribute('type', 'text/javascript');
          script.setAttribute('src', '/js/smartsupp.js');
          head.appendChild(script);
        }

        var query = $location.search();
        if (query['redirecting'] && query['redirecting'].toString() === '1') {
          $location.search('');
        } else {
          if (
            $state.current.name === 'home' ||
            $state.current.name === 'home.list'
          ) {
            if (!$scope.isAutologin) {
              $scope.$broadcast(
                'loadFolder',
                $scope.user.userPreferences.IdLastFolder
              );
              $scope.goTo($scope.user.userPreferences.IdLastFolder);
            }
          }
        }
      }

      function goTo(id) {
        var p = $state.params.page ? $state.params.page : 1;
        switch (id) {
          case -4:
            $state.go('home.checkouts', {
              page: p,
            });
            break;
          case -2:
            $state.go('home.shareds', {
              page: p,
            });
            break;
          case -3:
            $state.go('home.digitalizations', {
              page: p,
            });
            break;
          case -5:
            $state.go('home.favorites', {
              page: p,
            });
            break;
          case -6:
            $state.go('home.trashcan', {
              page: p,
            });
            break;
          case -7:
            $state.go('home.publicLinks', {
              page: p,
            });
            break;
          case -8:
            $state.go('home.myDeadLines', {
              page: p,
            });
            break;
          default:
            $state.go('home.folder', {
              id: id,
              page: p,
            });
            break;
        }
      }

      function run() {
        try {
          $scope.uploader = fileUploadService.getUploader();
          switch (webApiSettings.detailsCompany) {
            case 'abase':
              $rootScope.title = 'Abs-DOC - Gestão de Documentos';
              $rootScope.companyLogged = 'abase';
              break;
            case 'digitaldoc':
              $rootScope.title = 'Digitaldoc';
              $rootScope.companyLogged = 'digitaldoc';
              break;
            case 'hdoc':
              $rootScope.title = 'H5 Soluções - Gestão de Documentos';
              $rootScope.companyLogged = 'hdoc';
              break;
            case 'rb':
              $rootScope.title = 'RB Soluções - Gestão de Documentos';
              $rootScope.companyLogged = 'rb';
              break;
          }
          $scope.token = $state.params.t;

          if ($scope.token !== undefined) {
            authService.authentication.token = $scope.token;
            authService.authentication.isAuth = true;
            authService.authentication.isExternalLogin = true;
            authService.storeAuthData();
            $location.url('/');
          }

          if (!authService.authentication.isAuth) $location.path('/login');

          $scope.hasntCompanyImage = false;
          $scope.isLoading = false;
          $rootScope.onLogin = false;
          $rootScope.showSidebar = false;
          $scope.showProfileMenu = false;
          $scope.showSearch = false;
          $scope.loggedUser = $filter('translate')('LOADING');
          $scope.user = null;
          $scope.company = null;
          $scope.companyLogo = null;

          $window.onbeforeunload = logWrapper(
            onbeforeunload,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$on(
            'closeSearch',
            logWrapper(
              onCloseSearch,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $rootScope.$on(
            'treeItemSelected',
            logWrapper(
              onTreeItemSelected,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.showModules = logWrapper(
            showModules,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showSecurityModule = logWrapper(
            showSecurityModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showCrudModule = logWrapper(
            showCrudModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showReportModule = logWrapper(
            showReportModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showWorkflowModule = logWrapper(
            showWorkflowModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showMediaModule = logWrapper(
            showMediaModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNfeModule = logWrapper(
            showNfeModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLogoImg = logWrapper(
            getLogoImg,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.modules = [
            {
              title: 'MODULE.DOCUMENTS',
              icon: '/assets/images/modules/documents.png',
              ref: 'home',
              size: 20,
              baseRef: 'home',
              canShow: () => true,
            },
            {
              title: 'MODULE.FORMS',
              icon: '/assets/images/modules/forms.png',
              ref: 'modules.forms',
              baseRef: 'modules.forms',
              canShow: $scope.showCrudModule,
            },
            {
              title: 'MODULE.SECURITY',
              icon: '/assets/images/modules/security.png',
              ref: 'modules.security',
              baseRef: 'modules.security',
              canShow: $scope.showSecurityModule,
            },
            {
              title: 'MODULE.REPORTS',
              icon: '/assets/images/modules/reports.png',
              ref: 'modules.reports',
              baseRef: 'modules.reports',
              canShow: $scope.showReportModule,
            },
            {
              title: 'MODULE.WORKFLOW',
              icon: '/assets/images/modules/workflow.png',
              ref: 'flows.base',
              baseRef: 'flow',
              canShow: $scope.showWorkflowModule,
            },
            // {
            //   title: 'MODULE.MEDIA',
            //   icon: '/assets/images/modules/media.png',
            //   ref: 'modules.media',
            //   baseRef: 'modules.media',
            //   canShow: $scope.showMediaModule,
            // },
            {
              title: 'MODULE.NFE',
              icon: '/assets/images/modules/invoice.png',
              ref: 'modules.nfe',
              baseRef: 'modules.nfe',
              canShow: $scope.showNfeModule,
            },
          ];

          $scope.filterModules = logWrapper(
            filterModules,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.currentModule = logWrapper(
            currentModule,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateShowBar = logWrapper(
            updateShowBar,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateShowSearch = logWrapper(
            updateShowSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateCompany = logWrapper(
            validateCompany,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showChangePass = logWrapper(
            showChangePass,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showWiki = logWrapper(
            showWiki,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showSupportModal = logWrapper(
            showSupportModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showSupportWhatsapp = logWrapper(
            showSupportWhatsapp,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToMyDocuments = logWrapper(
            goToMyDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.verifySendFilesRunCallback = logWrapper(
            verifySendFilesRunCallback,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.logOut = logWrapper(
            logOut,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.switchCompany = logWrapper(
            switchCompany,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doSwitchCompany = logWrapper(
            doSwitchCompany,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadCompanyImage = logWrapper(
            loadCompanyImage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initialize = logWrapper(
            initialize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadData = logWrapper(
            loadData,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goTo = logWrapper(
            goTo,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
